import { IgMedia, IgMediaTime } from '@core/models/ApiFields/ig-entities';
import { DimCategory, Dimension } from '@features/social-analysis/models/IDimensions';
import { insightsMetrics, timeDims } from './insights';
import { initDim } from './insights-chart';
import { COMPONENTS_ENUM } from './page';

const mediaMetrics: DimCategory = {
    display: 'Media',
    values: [
        // {
        //     display: 'Captions negativity',
        //     value: IgMedia.getPrefixed('captionsNegativity'),
        //     prefix: IgMedia.prefix,
        // },
        // {
        //     display: 'Captions positivity',
        //     value: IgMedia.getPrefixed('captionsPositivity'),
        //     prefix: IgMedia.prefix,
        // },
        {
            display: 'Comments negativity',
            value: IgMediaTime.getPrefixed('commentsNegativity'),
            prefix: IgMediaTime.prefix,
        },
        {
            display: 'Comments positivity',
            value: IgMediaTime.getPrefixed('commentsPositivity'),
            prefix: IgMediaTime.prefix,
        },
        {
            display: 'Comments',
            value: IgMediaTime.getPrefixed('comments'),
            prefix: IgMediaTime.prefix,
        },
        {
            display: 'Followers from media',
            value: IgMediaTime.getPrefixed('followers'),
            prefix: IgMediaTime.prefix,
        },
        // {
        //     display: 'Impressions',
        //     value: IgMediaTime.getPrefixed('impressions'),
        //     prefix: IgMediaTime.prefix,
        // },
        {
            display: 'Interactions from media',
            value: IgMediaTime.getPrefixed('interactions'),
            prefix: IgMediaTime.prefix,
        },
        {
            display: 'Likes',
            value: IgMediaTime.getPrefixed('likes'),
            prefix: IgMediaTime.prefix,
            defaultCol: true,
        },
        // {
        //     display: 'Media count',
        //     value: IgMedia.getPrefixed('mediaCount'),
        //     prefix: IgMedia.prefix,
        //     defaultCol: true,
        // },
        // {
        //     display: 'Negative captions',
        //     value: IgMedia.getPrefixed('negativeCaptions'),
        //     prefix: IgMedia.prefix,
        // },
        {
            display: 'Negative comments',
            value: IgMediaTime.getPrefixed('negativeComments'),
            prefix: IgMediaTime.prefix,
        },
        // {
        //     display: 'Positive captions',
        //     value: IgMedia.getPrefixed('positiveCaptions'),
        //     prefix: IgMedia.prefix,
        // },
        {
            display: 'Positive comments',
            value: IgMediaTime.getPrefixed('positiveComments'),
            prefix: IgMediaTime.prefix,
        },
        {
            display: 'Profile activity from media',
            value: IgMediaTime.getPrefixed('profileActivity'),
            prefix: IgMediaTime.prefix,
        },
        {
            display: 'Profile visits from media',
            value: IgMediaTime.getPrefixed('profileViews'),
            prefix: IgMediaTime.prefix,
        },
        // {
        //     display: 'Reach',
        //     value: IgMediaTime.getPrefixed('reach'),
        //     prefix: IgMediaTime.prefix,
        //     defaultCol: true,
        // },
        // { display: 'Saves', value: IgMediaTime.getPrefixed('saves'), prefix: IgMediaTime.prefix },
        // { display: 'Shares', value: IgMediaTime.getPrefixed('shares'), prefix: IgMediaTime.prefix },
    ],
};

export const getInitMetrics = () => [
    insightsMetrics
        .flatMap(categ => categ.values)
        .find(opt => opt.value === IgMediaTime.getPrefixed('likes')) as Dimension,
    insightsMetrics
        .flatMap(categ => categ.values)
        .find(opt => opt.value === IgMediaTime.getPrefixed('comments')) as Dimension,
];

export const postChartInit = {
    component: COMPONENTS_ENUM.POST_CHART,
    dimOpts: [timeDims],
    metricOpts: [mediaMetrics],
    maxMetrics: 2,
    dimension: [initDim],
    metrics: getInitMetrics(),
};
